import React from 'react';

import PaperclipIcon from '@root/images/paperclip.svg';
import { Button } from '@shared/components/bootstrap';
import { Manager, Selector, Uploader } from '@shared/components/files';

export const FileFormControl: React.FC<{
  id: string;
  multiple?: boolean;
  disabled?: boolean;
  label?: string;
  accept: string;
  onUpload(file: File, signedID: string): void;
}> = ({ id, multiple, label, onUpload, accept, disabled }) => (
  <Manager onSave={onUpload}>
    {({ uploads }) => (
      <>
        <Button kind="primary" onClick={() => document.getElementById(`file-selector-${id}`)?.click()}>
          <img src={PaperclipIcon} alt="Paperclip Icon" style={{ filter: 'invert(100%)' }} />{' '}
          <Selector id={`file-selector-${id}`} disabled={disabled} multiple={!!multiple} accept={accept} />{' '}
          {label ?? 'Choose File'}
        </Button>
        {uploads.map((entry) => (
          <Uploader key={entry.uuid} {...entry} />
        ))}
      </>
    )}
  </Manager>
);
